import request from '@/utils/request';

export async function queryPortals() {
  return request('/portals');
}

export async function queryRolePortals(userId) {
  return request(`/users/${userId}/role/portals`);
}

export async function queryPortalsByUser(userId) {
  return request(`/users/${userId}/portals`);
}

export async function queryUserPortals(userId) {
  return request(`/users/${userId}/user/portals`);
}

export async function queryMenusByPortal(param) {
  return request(`/portals/${param.portalId}/dirmenus`);
}

export async function queryPortalsDirMenu(param) {
  return request(`/portals/${param.portalId}/party/${param.partyId}/dirmenus`);
}

// 更改用户权限
export async function changeUserPortals(userId, portalId, params) {
  return request(`/users/${userId}/user/portals?defaultPortalId=${parseInt(portalId, 10)}`, {
    method: 'POST',
    body: params,
  });
}
